<template>
  <div style="text-align:left">
    <Breadcrumb style="margin: 0px 10px 20px">
        <BreadcrumbItem to="/placementAdmin">版位管理</BreadcrumbItem>
        <BreadcrumbItem>新建版位</BreadcrumbItem>
    </Breadcrumb>
    <Card>
		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150" label-position="left" style="margin-left:10px">
            <FormItem label="版位类型" prop="medium_category">
                <RadioGroup v-model="formValidate.medium_category" @on-change="handleChangeCategory">
                    <Radio label="APP应用">APP应用</Radio>
                    <Radio label="微信小程序">微信小程序</Radio>
                    <Radio label="Web网页">Web网页</Radio>
                    <Radio label="体脂秤">体脂秤</Radio>
                    <Radio label="共享秤">共享秤</Radio>
                    <Radio label="专业秤">专业秤</Radio>
                </RadioGroup>
            </FormItem>
            <div v-show="formValidate.medium_category=='APP应用' || formValidate.medium_category=='微信小程序' || formValidate.medium_category=='Web网页'">
                <FormItem label="应用名称" prop="medium_name">
                    <Select v-model="formValidate.medium_name" style="width:300px" clearable filterable allow-create @on-create="handleCreate">
                        <Option v-for="(option, index) in mediumList" :value="option.medium_name" :key="index">{{option.medium_name}}</Option>
                    </Select>
                </FormItem>
            </div>

            <div v-show="formValidate.medium_category=='体脂秤' || formValidate.medium_category=='共享秤' || formValidate.medium_category=='专业秤'">
                <FormItem label="品牌" prop="brand">
                    <Input v-model="formValidate.brand" style="width:300px"></Input>
                </FormItem>
                <FormItem label="内部型号" prop="model">
                    <Input v-model="formValidate.model" type='textarea' :rows="3" style="width:300px" placeholder="不同内部型号间用“、”隔开，如US10、A890"></Input>
                </FormItem>
            </div>
            <FormItem label="广告版位名称" prop="placement_name">
                <Input v-model="formValidate.placement_name" style="width:300px"></Input>
            </FormItem>
            <FormItem label="版位样式" prop="template_id">
                <Select v-model="formValidate.template_id" style="width:300px" clearable @on-select="handleSeleteTemplate" @on-clear="handleClearTemplate">
                    <Option v-for="item in templates" :value="item.template_id" :key="item.template_id">
                        {{ item.template_name }}
                    </Option>
                </Select>
                <div class="box3" v-if="template_image != ''">
                    <img :src="template_image" alt="" style="max-height:130px;height:100%;border:1px solid rgb(158, 156, 156);float:left">
                    <div style="display: table-cell;height:150px;vertical-align: middle;margin-left:10px;text-align: center;padding-left: 10px;">
                        <p>{{template_description}}</p>
                        <p style="color:rgb(158, 156, 156);">{{template_size}}</p>
                    </div>
                </div>
            </FormItem>

            <div v-show="formValidate.template_id=='0'">
                <FormItem label="样式名称（必填）" prop="template_name">
                    <Input v-model="formValidate.template_name" style="width:300px"  @on-blur="handleBlur"></Input>
                </FormItem>
                <FormItem label="尺寸大小（必填）" prop="slot_size">
                    x: <InputNumber v-model="formValidate.size_x" :min="0" style="width:80px;margin-right:20px" placeholder="1080"></InputNumber>
                    y: <InputNumber v-model="formValidate.size_y" :min="0" style="width:80px" placeholder="1920"></InputNumber>
                </FormItem>
            </div>
            <FormItem label="广告投放数上限" prop="ad_num">
                <Input v-model="formValidate.ad_num" style="width:80px" type="number"></Input> 
            </FormItem>
            <FormItem label="版位预览图" prop="preview_url">
                <Upload
                    style="width:180px"
                    :before-upload="handleUpload"
                    type="drag"
                    action="">
                    <div v-if="!formValidate.preview_url">
                        <div style="display: table-cell;height:80px;vertical-align: middle;text-align: center;width:180px">
                            <p>点击上传</p>
                        </div>
                    </div>
                    <div v-if="formValidate.preview_url">
                        <el-image :src="formValidate.preview_url" style="width: 180px; height: 180px" fit="contain"></el-image>
                        <Spin fix v-show="uploading"></Spin>
                    </div>
                </Upload>
            </FormItem>
            <FormItem label="广告版位id" prop="placement_id" v-if="role_type==1 || role_type==3">
                <Input v-model="formValidate.placement_id" style="width:300px" placeholder="非版位id一致性问题，禁填此项"></Input>
            </FormItem>
            <FormItem label="备注" prop="remark">
                <Input v-model="formValidate.remark" type="textarea" style="width:300px"></Input> 
            </FormItem>

            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            </FormItem>
		</Form>
	</Card>
    
  </div>
</template>
<script>
import{mediaList, adTemplateList, createPlacement}from "@/request/api"
import Cookies from 'js-cookie';
import axios from 'axios';
export default {
  name: 'createPlacement',
  meta:{},
  data() {

    const validatePassCheck = (rule, value, callback) => {
        if (value - 0 < 1) {
            callback(new Error('广告投放数至少为1'));
        } else {
            callback();
        }
    };
    return {
        uploading: false,
        role_type: 0,
        exit_template_name:[],
        templates: [],
        template_dict: {},
        template_image: "",
        formValidate:{
            medium_category: 'APP应用',
            medium_name: '',
            template_id: '',
            template_name: '',
            size_x: 0,
            size_y: 0,
            ad_num: '1',
            preview_url: '',
            remark: ''
        },
        medias: {},
        mediumList: [],
        total_count:0,
        page:1,
        ruleValidate: {
                placement_name: [
                    { required: true, message: 'The name cannot be empty', trigger: 'blur' }
                ],
                medium_category: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                medium_name: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                template_id: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                ad_num: [
                    { required: true, message: '请输入', trigger: 'change' },
                    { validator: validatePassCheck, trigger: 'change' }
                ],
                preview_url: [
                    { required: true, message: '请上传版位预览图', trigger: 'blur' }
                ],
            }
        };
    },
    methods: {
        getAdTemplateList(){
            adTemplateList().then(res=>{
                if(res.data.code==200){
                    this.templates=res.data.data.templates
                    this.templates.push({
                        template_id: '0',
                        template_name: "自定义",
                        image: ''
                    })
                    this.templates.forEach((item, index) => {
                        this.template_dict[item.template_id+''] = item
                        this.exit_template_name.push(item.template_name)
                    })
                }
            })
        },
        getMediaList(){
            mediaList().then(res=>{
                if(res.data.code==200){
                    this.medias = res.data.data.categorys
                    let list1 = this.medias[this.formValidate.medium_category]
                    if (list1){
                        this.mediumList=list1
                    }
                }
            })
        },
        handleChangeCategory(value){
            let list1 = this.medias[value]
            if (list1){
                this.mediumList=list1
            }else{
                this.mediumList = []
            }
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if (this.formValidate.template_id=='0' && this.formValidate.template_name.trim() ==''){
                        this.$Message.error('样式名称不能为空');
                        return
                    }else if(this.formValidate.template_id=='0' && this.exit_template_name.indexOf(this.formValidate.template_name.trim()) !== -1 ){
                        this.$Message.error('样式名称已存在');
                        return
                    }else if(this.formValidate.template_id=='0' && (!this.formValidate.size_x || !this.formValidate.size_y)){
                        this.$Message.error('尺寸大小不能为空');
                        return
                    }
                    createPlacement(
                        {
                            medium_name: this.formValidate.medium_name,
                            medium_category: this.formValidate.medium_category,
                            placement_id: this.formValidate.placement_id,
                            placement_name: this.formValidate.placement_name,
                            template_id: this.formValidate.template_id,
                            template_name: this.formValidate.template_name,
                            size_x: this.formValidate.size_x,
                            size_y: this.formValidate.size_y,
                            ad_num: this.formValidate.ad_num - 0,
                            preview_url: this.formValidate.preview_url,
                            remark: this.formValidate.remark
                        }
                    ).then(res=>{
                        if(res.data.code==200){
                            this.$Message.success('Success!');
                            this.$router.back(-1);
                        }else{
                            this.$Message.error(res.data.msg);
                        }
                    })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        handleSeleteTemplate(item){
            this.template_image = this.template_dict[item.value+'']['image']
            this.template_description = this.template_dict[item.value+'']['description']
            this.template_size = this.template_dict[item.value+'']['size']
        },
        handleClearTemplate(){
            this.template_image = ""
        },
        handleBlur(){
            if (this.formValidate.template_name.trim() ==''){
                this.$Message.error('样式名称不能为空');
            }else if(this.exit_template_name.indexOf(this.formValidate.template_name.trim()) !== -1 ){
                this.$Message.error('样式名称已存在');
            }
        },
        handleCreate(val){
            this.mediumList.push({
                medium_name: val
            });
        },
        handleUpload(file){
            this.uploading=true;
            let file_size = file.size
            if (file_size > 150 * 1024) {
                this.$Message.error("素材大小不能超过150kb")
                this.uploading=false;
                return false
            }
            let file_type = file.type.split("/")[1]
            let image_tyles = ['png','jpg','bmp','gif','jpeg']
            if (image_tyles.indexOf(file_type) > -1){
                this.uploadFiles(file)
            }else{
                this.$Message.error("格式有误，图片支持（png|jpg|gif|bmp|jpeg）")
                this.uploading = false
            }
            return false
        },
        // 上传七牛云
        uploadFiles(file){
            new Promise(resolve=>{
                axios.get('https://pms.yolanda.hk/base/get_qiniu_uptoken_for_web?upload_type=advertisement',{
                                    
                }).then(res=>{    
                    let formData=new FormData()
                    formData.append('token',res.data.uptoken)
                    formData.append('file',file)
                    formData.append('key','placement_' + new Date().getTime())
                    axios.post('https://up-z0.qiniup.com',formData).then(res=>{
                        this.formValidate.preview_url = 'https://qnplus-advertisement.qnniu.com/'+res.data.key
                        this.uploading = false
                    })              
                })                  
            })                      
        },
    },
    created() {
        let userInfo = Cookies.get('userInfo')
        if (userInfo){
            this.role_type = JSON.parse(userInfo).role_type
        }
        Cookies.set('active_name', '4');
        this.getMediaList()
        this.getAdTemplateList()
    },
};
</script>
<style scoped>
.box{
  width: 300px;
  height: 280px;
  border:1px solid rgb(158, 156, 156);
  padding: 10px;
  /* margin: 0px 20px 20px; */
}
.box1{
  width: 300px;
  /* height: 280px; */
  border:1px solid rgb(158, 156, 156);
  padding: 10px 10px 20px;
  /* margin: 0px 20px 20px; */
}
.box2{
  width: 400px;
  /* height: 280px; */
  border:1px solid rgb(158, 156, 156);
  padding: 10px 10px 20px;
  /* margin: 0px 20px 20px; */
}
.box3{
  max-height:150px;
  max-width:300px;
  /* border:1px solid rgb(158, 156, 156); */
  margin-top: 20px;
  text-align: left;
  /* float: left; */
  overflow: hidden;
  /* width: 200px; */
  /* padding: 10px; */
}

</style>


// WEBPACK FOOTER //
// src/views/Placement/PlacementCreate.vue